import React, { useState } from 'react';
import GoogleMapReact from 'google-map-react';
import LocationPin from './LocationPin';
import ReactGoogleAutoComplete from 'react-google-autocomplete';

const Map = () => {
  const [selectedLocation, setSelectedLocation] = useState(null);

  const handleApiLoaded = (map, maps) => {
    // You can access the map and maps objects here.
  };

  const handlePlaceSelect = (place) => {
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    const address = place.formatted_address;

    setSelectedLocation({ lat, lng, address });
  };

  const zoomLevel = 17;

  return (
    <div>
      <div style={{ margin: '10px' }}>
        <ReactGoogleAutoComplete
          apiKey="AIzaSyDB3s6JNILyhY6IVO68-kCAgH5_N-5LP_I"
          onPlaceSelected={handlePlaceSelect}
          types={['(regions)']} 
        />
      </div>
      <div style={{ height: '400px', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyDB3s6JNILyhY6IVO68-kCAgH5_N-5LP_I' }}
          defaultCenter={{ lat: 37.42216, lng: -122.08427 }}
          defaultZoom={zoomLevel}
          yesIWantToUseGoogleMapApiInternals={true}
          onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
        >
          {selectedLocation && (
            <LocationPin
              lat={selectedLocation.lat}
              lng={selectedLocation.lng}
              text={selectedLocation.address}
            />
          )}
        </GoogleMapReact>
      </div>
    </div>
  );
};

export default Map;
